export default __webpack_public_path__ + "static/media/chrome.a56f9f0d.svg";